import supportedLocales from '../supportedLocales'

/**
 * Only Localized for listed routes. Ideally we should
 * make locale source for different url consistency
 */
const URLLocalizableRoutes = ['/dasher/signup/']

/**
 * This method verifies if the route is in URLLocalizableRoutes
 *
 * @param {string} pathname - URL pathname
 * @return {boolean} If the route belongs to localized routes or not
 */
const getIsUrlLocalizableRoute = (pathname: string) =>
  URLLocalizableRoutes.some(route =>
    Object.values(supportedLocales)
      .map(lng => `/${lng.value}${route}`)
      .some(localePrefixedRoute => localePrefixedRoute.includes(pathname))
  )

export default getIsUrlLocalizableRoute
